import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=de6e00da&scoped=true&functional=true"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./VxBreadcrumb.vue?vue&type=style&index=0&id=de6e00da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "de6e00da",
  null
  
)

export default component.exports